import React, { useState, useEffect } from 'react';
import { Backdrop, CircularProgress } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import MobileMyProducts from '../components/MobileMyProducts';
import MobileMyContracts from '../components/MobileMyContract';
import MobileMyPersonalSpace from '../components/MobileMyPersonalSpace';
import MobileMyFarm from '../components/MobileMyFarm';
import MobileMenuPanel from '../components/MobileMenuPanel';
import { logout } from '../Redux/user/slice';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastProperties } from '../utils/constants/toastProperties';
import { isAuthenticated } from '../utils/tokenValidator';
import { FormattedMessage } from "react-intl";
import { IconLeaf, IconShoppingCart, IconTractor, IconUser } from '@tabler/icons-react';

const TABS = [
  { id: 'myproducts',      Icon: IconLeaf,         labelId: 'mylist.navbar.products'     },
  { id: 'mycontracts',     Icon: IconShoppingCart, labelId: 'mylist.navbar.cart'          },
  { id: 'myfarm',          Icon: IconTractor,      labelId: 'mylist.navbar.myFarm'        },
  { id: 'mypersonalspace', Icon: IconUser,         labelId: 'mylist.navbar.userSettings'  },
];

const MobileMyList = () => {
  const [activeTab, setActiveTab] = useState('myproducts');
  const props = useSelector((state) => state.properties);
  const prodStore = useSelector((state) => state.products);
  const user = useSelector((state) => state.user.userInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isAuthenticated()) {
      console.warn('Token expired or invalid - logging out user');
      toast.error(<FormattedMessage id="toast.sessionexpired" />, ToastProperties);
      // Preserve tour completion - only clear user-specific data
      const tourCompleted = localStorage.getItem('vertoWorkspaceTourCompleted');
      localStorage.clear();
      if (tourCompleted) {
        localStorage.setItem('vertoWorkspaceTourCompleted', tourCompleted);
      }
      dispatch(logout());
      setTimeout(() => { window.location.href = '/'; }, 1000);
    }
  }, [dispatch]);

  const renderContent = () => {
    switch (activeTab) {
      case 'myproducts':      return <MobileMyProducts />;
      case 'mycontracts':     return <MobileMyContracts />;
      case 'myfarm':          return <MobileMyFarm />;
      case 'mypersonalspace': return <MobileMyPersonalSpace />;
      default:                return <MobileMyProducts />;
    }
  };

  const userInfoContainerStyle = {
    padding: '10px 15px',
    backgroundColor: '#3498DB',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontFamily: "'Montserrat', sans-serif",
    color: 'white',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    flexShrink: 0,
  };

  const userInfoTextStyle = {
    width: '50%',
    textAlign: 'center',
    fontSize: '0.85rem',
    letterSpacing: '0.3px',
    fontWeight: '500',
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
      backgroundColor: 'white',
    }}>

      <MobileMenuPanel />

      {user && (
        <div style={userInfoContainerStyle}>
          <span style={userInfoTextStyle}>
            <FormattedMessage id="userInfo.userID" /> {user.userId}
          </span>
          <span style={userInfoTextStyle}>
            <FormattedMessage id="userInfo.address" /> {user.accountId}
          </span>
        </div>
      )}

      {/* Top tab bar */}
      <div style={{
        display: 'flex',
        flexShrink: 0,
        backgroundColor: 'white',
        boxShadow: '0 1px 0 #e0e0e0',
        padding: '0 4px',
      }}>
        {TABS.map(({ id, Icon, labelId }) => {
          const isActive = activeTab === id;
          return (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none',
                background: 'none',
                cursor: 'pointer',
                padding: '12px 8px',
                color: isActive ? '#2E7D32' : '#9e9e9e',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '0.7rem',
                letterSpacing: '0.3px',
                fontWeight: isActive ? 600 : 400,
                gap: '5px',
                borderBottom: isActive ? '2px solid #2E7D32' : '2px solid transparent',
                transition: 'color 0.15s ease, border-color 0.15s ease',
              }}
            >
              <Icon size={20} stroke={isActive ? 2 : 1.5} />
              <FormattedMessage id={labelId} />
            </button>
          );
        })}
      </div>

      {/* Scrollable content area */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {renderContent()}
      </div>

      <Backdrop open={props.fetching || prodStore.fetching} style={{ zIndex: 1500 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default MobileMyList;